import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import ButtonPrimary from "../../Elements/ButtonPrimary";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faQrcode} from "@fortawesome/free-solid-svg-icons";



const RowContent = ({ title, label, rightIcon, titleColorClass }) => (
    <div>
        <div className='d-flex align-items-center'>
            {
                rightIcon &&
                    <div className='img-cnt-24 d-flex align-items-center justify-content-center ml-20'>
                        {
                            rightIcon
                        }
                    </div>
            }
            <div className={`mobile-subtitle-strong ${titleColorClass}`}>
                {title}
            </div>
        </div>
        {
            label &&
            <div className='mobile-body-1-regular cl-subtitle mt-6'>
                {label}
            </div>
        }
    </div>
);

const PanelRow = (
    {
        children, // used for modal content
        className = '',
        title,
        titleColorClass = 'cl-black',
        rightIcon,
        label,
        operationTitle = 'تغییر',
        href,
        linkState,
        modalKey,
        activeModal,
        setActiveModal,
        hasDivider = true
    }
) => {
    return (
        <>
            {href ? (
                <Link
                    to={href}
                    state={linkState}
                    className={`d-flex align-items-center justify-content-between td-none mt-12 ${className}`}
                >
                    <RowContent title={title} label={label} rightIcon={rightIcon} titleColorClass={titleColorClass}/>
                    <div className='img-cnt-24'>
                        <img src={"/assets/images/vectors/arrow_left_gray.svg"} alt='link'/>
                    </div>
                </Link>
            ) : (
                <div
                    className={`d-flex align-items-center justify-content-between mt-12 cursor-pointer ${className}`}
                    onClick={() => setActiveModal(modalKey)}
                >
                    <RowContent title={title} label={label} rightIcon={rightIcon} titleColorClass={titleColorClass}/>
                    <div className='mobile-button-small cl-blue'>
                        {operationTitle}
                    </div>
                </div>
            )}

            {
                hasDivider && <div className='divider-1px bg-gray-custom-1 mt-12'/>
            }

            {!href && activeModal === modalKey && (
                <Modal className='bottom-sheet fade in'
                       show={activeModal === modalKey}
                       onHide={() => setActiveModal(null)}>
                    <Modal.Body>
                        <div className='d-flex justify-content-center pt-10 pb-10'
                             onClick={() => setActiveModal(null)}>
                            <div className='bottom-sheet-close-line btn p-0 '/>
                        </div>
                        {children}
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

export default PanelRow;
